import React, {Component} from 'react';
import {connect} from 'react-redux';
import Action from 'components/organisms/player-name-stacking/actions';
import Const from 'constants';
import {showPopup} from 'helpers/modal';
import MultiSelect from 'components/atoms/dropdowns/multi-select';
import SelectKeyPlayer from './select-key-player';

const defaultState = {
    keyPlayers: [],
    stackWith: Const.STACK_WITH_PLAYER,
    type: Const.STACKS_TYPE_AT_LEAST,
    numberPlayers: 0,
    selectedPositions: [],
    selectedPlayers: [],
    isSameTeam: true,
};

class Settings extends Component {
    constructor(props) {
        super(props);
        this.signature = null;
        this.state = cp(defaultState);
    }

    componentDidUpdate(prevProps) {
        const {stacking} = this.props;
        const isStackingSignatureChanged = stacking.getSignature() !== this.signature;

        if (isStackingSignatureChanged) {
            this.signature = stacking.getSignature();
            this.setState(cp(defaultState));
        }
    }

    selectKeyPlayer(value) {
        this.setState({
            keyPlayers: value ? [value] : [],
        });
    }

    selectPlayer(selectedValues) {
        const selectedPlayers = selectedValues.map((value) => String(value));

        this.setState({selectedPlayers});
    }

    selectType(e) {
        this.setState({type: e.target.value});
    }

    selectNumberPlayers(e) {
        this.setState({numberPlayers: Number(e.target.value)});
    }

    validateStack(settings) {
        try {
            if (isEmpty(settings.selectedPlayers) || isEmpty(settings.keyPlayers)) {
                throw new Error('You should select a player.');
            }
            if (!isEmpty(arrayDuplicates(settings.keyPlayers, settings.selectedPlayers))) {
                throw new Error('You should select different players.');
            }
            if (settings.selectedPlayers.length < settings.numberPlayers) {
                throw new Error('You should add more players.');
            }

            return true;
        } catch (e) {
            this.props.dispatch(showPopup(e.message));
        }

        return false;
    }

    addStack() {
        const settings = {...this.state};

        if (this.validateStack(settings)) {
            this.props.dispatch(Action.do('addItemToPlayerNameStacking', settings));
        }
    }

    getTypeBlock() {
        return (
            <select onChange={(e) => ::this.selectType(e)} value={this.state.type} className="form-control input-md">
                <option value={Const.STACKS_TYPE_AT_LEAST}>No less than</option>
                <option value={Const.STACKS_TYPE_EXACTLY}>Exactly</option>
                <option value={Const.STACKS_TYPE_AT_MOST}>No more than</option>
            </select>
        );
    }

    getPlayersNumberBlock() {
        return (
            <select
                onChange={(e) => ::this.selectNumberPlayers(e)}
                value={this.state.numberPlayers}
                className="form-control input-md"
            >
                <option value={0}>0 Players</option>
                <option value={1}>1 Player</option>
                <option value={2}>2 Players</option>
                <option value={3}>3 Players</option>
                <option value={4}>4 Players</option>
            </select>
        );
    }

    prepareStackingBlock() {
        const {players} = this.props;

        const playerOptions = Object.values(players.all()).map((player) => {
            return {
                value: player.playerId,
                label: player.name,
            };
        });

        return (
            <>
                {this.getTypeBlock()}
                {this.getPlayersNumberBlock()}
                <div className="form-text">of</div>
                <MultiSelect onSelect={::this.selectPlayer} options={playerOptions} placeholder={'Select player'} />
            </>
        );
    }

    getKeyPlayer() {
        return this.state.keyPlayers[0] ?? '';
    }

    render() {
        const {players} = this.props;

        if (isEmpty(players.all())) {
            return null;
        }

        return (
            <div className="white-box">
                <h3>Create New Rule</h3>
                <div className="gray-holder">
                    <div className="form-inline">
                        <div className="form-text">Stack</div>
                        <SelectKeyPlayer
                            key={`keyPlayer-${this.getKeyPlayer()}`}
                            players={Object.values(players.all())}
                            value={this.getKeyPlayer()}
                            onChange={::this.selectKeyPlayer}
                        />
                        <div className="form-text">with</div>
                        {this.prepareStackingBlock()}
                        <button type="submit" onClick={::this.addStack} className="btn">
                            Add Rule
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {
        sportConfig,
        playerNameStacking,
        playersData: {players},
    } = state;

    return {
        sportConfig,
        stacking: playerNameStacking,
        players,
    };
}

export default connect(mapStatesToProps)(Settings);

export {Settings};
